import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=2ad81113&scoped=true"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"
import style0 from "./CityList.vue?vue&type=style&index=0&id=2ad81113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad81113",
  null
  
)

export default component.exports